import { LoaderType } from 'editor/src/store/app/types';
import { RootState } from 'editor/src/store/index';

import isLoaderActive from './isLoaderActive';

// Only a switch to CMYK waits, for the print profile; see setDesignColorSpaceOperation.
const isSwitchingToCMYK = (state: RootState) => !!isLoaderActive(state, LoaderType.ColorSpaceSwitch);

export default isSwitchingToCMYK;
